// Helpers guides : ouvrir le menu avant coblage nav-*, le fermer après navigation.
import type { DriveStep } from 'driver.js';
import type { TourLayoutShell } from './types';

export const MENU_TOGGLE_SELECTOR = '[data-tour="menu-toggle"]';

export function isNavTourSelector(element: DriveStep['element']): boolean {
  if (typeof element !== 'string') return false;
  return /data-tour=["']nav-/.test(element);
}

export function tourFirstStepNeedsMenu(steps: DriveStep[]): boolean {
  return isNavTourSelector(steps[0]?.element);
}

export function navThen(
  path: string,
  pathname: string,
  navigate: (to: string) => void,
  drv: { moveNext: () => void },
  layoutShell?: TourLayoutShell | null
) {
  const pathOnly = path.split('?')[0];
  const alreadyOnPage =
    pathname === pathOnly || pathname.startsWith(`${pathOnly}/`);

  const finish = (delayMs: number) => {
    // Desktop : menu reste ouvert. Mobile : fermer après navigation vers le module.
    if (layoutShell?.isMobileShell) {
      layoutShell.closeMenu();
    }
    if (delayMs <= 0) {
      drv.moveNext();
      return;
    }
    window.setTimeout(() => drv.moveNext(), delayMs);
  };

  // Toujours naviguer si query (ex. ?tab=) pour activer le bon onglet.
  if (path.includes('?') || !alreadyOnPage) {
    navigate(path);
    finish(600);
    return;
  }

  finish(layoutShell?.isMobileShell ? 350 : 0);
}
